import React from 'react';
import Navbar from '../components/layout/Navbar';
import EditRecipientsForm from '../components/layout/EditRecipientsForm';

function EditRecipientsPage() {
  return (
    <div>
      <Navbar />
      <div className='container'>
        <EditRecipientsForm />
      </div>
    </div>
  );
}

export default EditRecipientsPage;
